module.exports = __webpack_public_path__ + "media/images/heart-4033346dad66ca435d33ea1eec754812.svg";